import React from 'react'
import SwitchToUser from './SwitchToUser'
import MergeUser from './MergeUser'

const Support = () => (
    <div>
        <SwitchToUser />
        <MergeUser />
    </div>
)

export default Support
